// extracted by mini-css-extract-plugin
export default {"calendarFilter":"StatoInvioPremalNav_calendarFilter__ggUZZ","leftDivider":"StatoInvioPremalNav_leftDivider__8XVMP"};